import {
    WITHDRAWEMONEY_APPROVEREJECT_SUCCESS,
    WITHDRAWEMONEY_APPROVEREJECT_FAILED,
    RESET_WITHDRAWEMONEY_APPROVEREJECT,
    LOADING_WITHDRAWEMONEY_APPROVEREJECT,
    WITHDRAWEMONEY_APPROVEREJECT_NETWORKERROR,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_WITHDRAWEMONEY_APPROVEREJECT:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case WITHDRAWEMONEY_APPROVEREJECT_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case WITHDRAWEMONEY_APPROVEREJECT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case WITHDRAWEMONEY_APPROVEREJECT_NETWORKERROR:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_WITHDRAWEMONEY_APPROVEREJECT:
            return (state = initialState);
        default:
            return state;
    }
};
